var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "#FAFAFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40008511_41275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.2058 21.2996C38.5217 21.5374 38.9681 21.4712 39.2026 21.1526C39.4377 20.8341 39.3731 20.3826 39.0573 20.1448L38.0201 19.3648C37.7057 19.1264 37.2591 19.1939 37.0239 19.5125C36.7888 19.831 36.8542 20.2826 37.17 20.5197L38.2058 21.2996Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.0678 19.7009C42.4616 19.7009 42.7802 19.3788 42.7802 18.9807V17.6761C42.7802 17.278 42.4616 16.9559 42.0678 16.9559C41.6741 16.9559 41.3555 17.278 41.3555 17.6761V18.9807C41.3556 19.3788 41.6742 19.7009 42.0678 19.7009Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9273 21.2996L46.9631 20.5197C47.2789 20.282 47.3436 19.8304 47.1084 19.5118C46.8734 19.1918 46.4267 19.1271 46.1116 19.3648L45.0758 20.1448C44.76 20.3825 44.6953 20.8341 44.9305 21.1526C45.1645 21.4705 45.6108 21.5379 45.9273 21.2996Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.1092 54.9294C47.3436 54.6101 47.2782 54.1593 46.9624 53.9216L45.9272 53.1423C45.6114 52.9053 45.1656 52.9699 44.9304 53.2893C44.6954 53.6078 44.76 54.0593 45.0758 54.2971L46.1122 55.0777C46.4269 55.3141 46.8736 55.2493 47.1092 54.9294Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.7802 56.7663V55.4609C42.7802 55.0628 42.4616 54.7407 42.0678 54.7407C41.6741 54.7407 41.3555 55.0628 41.3555 55.4609V56.7663C41.3555 57.1644 41.6741 57.4865 42.0678 57.4865C42.4616 57.4865 42.7802 57.1644 42.7802 56.7663Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2037 53.2873C39.4387 53.6114 39.3746 54.058 39.0541 54.2956L38.0213 55.0806C37.7078 55.3111 37.259 55.2463 37.0241 54.9294C36.789 54.6125 36.853 54.1587 37.1736 53.9211L38.2065 53.1432C38.5198 52.9056 38.9686 52.9704 39.2037 53.2873Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.5545 27.6273C46.3262 22.334 37.8069 22.334 32.5715 27.6273C27.5354 32.7262 27.3075 40.9002 32.1014 46.28L30.8833 47.5042C29.6368 46.7264 28.0768 46.9352 27.0795 47.9507L17.4277 57.7092C16.2168 58.9334 16.2168 60.914 17.4277 62.1311C18.6315 63.3482 20.5903 63.3482 21.7942 62.1311L31.4531 52.3655C32.4789 51.3284 32.6214 49.7296 31.8877 48.5269L33.1058 47.2954C38.4267 52.1422 46.5328 51.8901 51.5546 46.8128C56.7829 41.5196 56.7901 32.9135 51.5545 27.6273ZM50.5431 45.7975C45.8703 50.5219 38.2628 50.5219 33.5901 45.7975C28.9031 41.0587 28.896 33.3816 33.583 28.6428C38.2628 23.9185 45.8703 23.9185 50.5502 28.6428C55.2231 33.3744 55.2231 41.0658 50.5431 45.7975Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2629 35.4514C39.6567 35.4514 39.9753 35.1293 39.9753 34.7312C39.9753 33.5665 40.9122 32.6192 42.0636 32.6192C43.2155 32.6192 44.1525 33.5665 44.1525 34.7312C44.1525 35.8951 43.2155 36.8425 42.0636 36.8425C41.6698 36.8425 41.3512 37.1646 41.3512 37.5627V38.7443C41.3512 39.1424 41.6698 39.4645 42.0636 39.4645C42.4573 39.4645 42.7759 39.1424 42.7759 38.7443V38.2097C44.373 37.8757 45.5772 36.4431 45.5772 34.7312C45.5772 32.7725 44.001 31.1788 42.0637 31.1788C40.1264 31.1788 38.5508 32.7725 38.5508 34.7312C38.5506 35.1293 38.8692 35.4514 39.2629 35.4514Z",
    fill: "#6E6E6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5633 42.0309C41.3286 42.2682 41.2468 42.6989 41.5633 43.0536C41.902 43.3625 42.3072 43.3141 42.5678 43.0536C42.8464 42.7719 42.8569 42.3248 42.5678 42.0309C42.2936 41.7568 41.8435 41.7565 41.5633 42.0309Z",
    fill: "#6E6E6E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40008511_41275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 47,
    fill: "white",
    transform: "translate(16 16.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/empty-state.87b9016b898b2606814ec0d2b7179fd4.svg";
export { ForwardRef as ReactComponent };